module.exports = __webpack_public_path__ + "img/rodapeAzul.75b08023.png";